// Dosage forms a generic SIG can be tied to. Matched against the master medicine
// `type` by "contains" ("Tablet (Film Coated)" -> Tablet), so order matters:
// more specific words first ("Powder for Suspension" -> Suspension).
const DOSAGE_FORMS = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Suspension",
    "Drop",
    "Injection",
    "Infusion",
    "Cream",
    "Ointment",
    "Gel",
    "Inhaler",
    "Suppository",
    "Powder",
    "Solution",
];

// Forms usually dosed by weight/age (children): a saved SIG is offered for these
// but never auto-filled.
const WEIGHT_DOSED_FORMS = ["Syrup", "Suspension", "Drop", "Solution", "Powder"];

module.exports = { DOSAGE_FORMS, WEIGHT_DOSED_FORMS };
